import React from 'react'
import { css } from '@emotion/core'

export default function Tooltip({
  tooltipContent,
  tooltipX = 18,
  tooltipY = 27,
  showTooltip,
  setTooltipX,
  setTooltipY,
  fixed = false,
}) {
  const primaryColor = `rgba(40,40,40,.8)`

  const tooltipCss = css`
    position: ${fixed ? 'fixed' : 'absolute'};
    left: ${tooltipX - 24}px;
    top: ${tooltipY - 50}px;
    display: ${showTooltip ? '-webkit-box' : 'none'};
    font-size: 15px;
    border-radius: 4px;
    padding: 10px 15px;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);
    z-index: 4;
    background: ${primaryColor};
  `
  const contentCss = css`
    color: white;
    font-size: 12px;
    display: flex;
  `

  const onMouseOver = (event) => {
    if (setTooltipX) {
      setTooltipX(event.clientX)
      setTooltipY(event.clientY)
    }
  }

  const triangleCss = css`
    width: 0;
    height: 0;
    position: absolute;
    top: 35px;
    left: 16px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid ${primaryColor};
  `

  return (
    <div css={tooltipCss} onMouseOver={onMouseOver} onFocus={onMouseOver}>
      <div css={triangleCss} />
      <div css={contentCss}>{tooltipContent}</div>
    </div>
  )
}
